import { getSignalEventDate } from "app/pages/sales-intelligence/modules/company-analysis/services/signals/getters/getSignalEventDate";
import type { SignalEventDto } from "app/pages/sales-intelligence/modules/company-analysis/types/signals";
import type { ReactElement } from "react";
import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

import signalsService from "../../../services/signalsService";
import { StyledEventDate, StyledEventItemWrapper, StyledIcon, StyledIconWrapper } from "./styles";

export type SignalEventItemProps = {
    className?: string;
    children: ReactElement;
    signalEvent: Readonly<SignalEventDto>;
};

const SignalEventItem = (props: SignalEventItemProps) => {
    const { signalEvent, className, children } = props;

    return (
        <StyledEventItemWrapper className={className}>
            <StyledIconWrapper>
                <StyledIcon
                    iconName={signalsService.getIconForSignalType(signalEvent.type)}
                    size="xs"
                />
            </StyledIconWrapper>

            <FlexColumn>
                {children}
                <StyledEventDate>{getSignalEventDate(signalEvent.eventHappenedDaysAgo)}</StyledEventDate>
            </FlexColumn>
        </StyledEventItemWrapper>
    );
};

export default SignalEventItem;
